<template>
  <v-container fluid grid-list-xl page>
    <v-layout row wrap>
      <v-flex xs12 sm8 md12>
        <section-header v-text="page.headline"></section-header>
        <div class="subheading justify" v-html="page.description"></div>
        <div class="my-5"></div>
      </v-flex>
    </v-layout>
    <!-- Your contet -->

    <div class="display-2 grey--text text--darken-1">
      Envia una notificación
    </div>
    <div class="title grey--text text--darken-1">
      desde cualquier dispositivo sin necesidad de instalar una aplicación
    </div>

    <v-layout>
      <v-flex>
        <v-card class="justify-center">
          <v-container fluid grid-list-md>
            <v-layout row wrap class="justify-center">
              <v-flex xs12 md6 lg3 offset-2>
                <v-card flat tile>
                  <v-img
                    justify-center
                    src="/static/send.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">NOTIFICA</h3>
                      <div>
                        Al contrario que el e-mail o SMS no certificados, las
                        notificaciones certificadas permiten realizar
                        comunicaciones garantizadas mediante la trazabilidad de
                        la entrega y lectura, certificando ak mismo tiempo el
                        contenido por medio de tecnología de cifrado.
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    src="/static/digital-signature.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">TOMA EL CONTROL</h3>
                      <div>
                        Con las Notificaciones Certificadas de Securyty podrás
                        enviar información relevante por medio de e-mail o SMS,
                        con registro de la entrega y con un coste mucho menor
                        que las alternativas tradicionales
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    s
                    src="/static/admin.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">GESTIONA</h3>
                      <div>
                        Monitoriza el estado de tus notificaciones desde un
                        panel de control, con seguimiento de su evolución
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>
  

    <v-layout height="100">
      <v-card height="100" flat color="grey"> </v-card>
    </v-layout>

    <div class="display-2 black--text text--darken-3 justify-center"></div>
    <div class="title black--text text--darken-1"></div>

    <v-dialog v-model="isCreateSign" persistent max-width="500px">
      <v-card>
        <v-toolbar color="orange" dark>
          <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
          <v-toolbar-title>Crea una Notificación Certificada</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip right>
            <v-icon slot="activator" color="white" dark>help_outline</v-icon>
            <span
              ><b
                >Notificación Certificada : <br /><br />- Envía documentos y
                sigue su estado<br /><br />
              </b>
            </span>
          </v-tooltip>
        </v-toolbar>
        <create-sign-page
          :scroll-top="scrollTop"
          signature-type="notification"
        ></create-sign-page>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="closeSignaturePage"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isLoginNeeded" max-width="300px">
      <v-card>
        <v-toolbar color="orange" dark>
          <v-toolbar-title>Acceso requerido</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap></v-layout>
            <span
              >Por favor, accede a tu cuenta o registrate antes de iniciar la
              prueba
            </span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="isLoginNeeded = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CreateSignPage from "./CreateSignPage";

export default {
  components: {
    CreateSignPage
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      isLoginNeeded: false,
      isCreateSign: false,
      page: {
        title: "Notificación Certificada",
        headline: "Notificación Certificada",
        description: `Envia una notificación certificada por email`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      scrollTop: 0
    };
  },
  methods: {
    createSignature() {
      //this.$router.push("CreateSignPage")
      var current = this.$store.getters.userData;
      if (current == null || current.userEmail == null) {
        this.isLoginNeeded = true;
        this.$ga.event({
          eventCategory: "Loggin needed certified notification", // str
          eventAction: "click", // str
          eventLabel: "TryButton", // str
          eventValue: 0 // int
        });
        return;
      }
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.getElementsByTagName("body")[0].className = "noscroll";
      this.isCreateSign = true;
    },
    closeSignaturePage() {
      document.body.removeAttribute("class", "noscroll");
      window.scrollTo(0, this.scrollTop);
      this.isCreateSign = false;
    }
  }
};
</script>
